export const inBrowser = typeof window !== 'undefined'


function isClientAgent(regexp: RegExp) {
    return inBrowser ? regexp.test(navigator.userAgent) : false;
}
export function isAndroid() {
    return isClientAgent(/Android/i);
}
export function isIOS() {
    return isClientAgent(/ios|iPhone|iPad|iPod/i);
}
export function isSafari() {
    return isClientAgent(/Safari/i);
}
export function isUCBrowser() {
    return isClientAgent(/UCBrowser|UCWEB/i);
}

/**
 * 微信环境
 * - 微信小程序
 * - 微信浏览器
 */
export function isWechat() {
    return isClientAgent(/MicroMessenger/i);
}
export function isAlipay() {
    return isClientAgent(/AlipayClient/i);
}
export function isPCWechat() {
    return isClientAgent(/WindowsWechat/i);
}


/**
 * 字节小程序
 */
export function isByteapp() {
    return isClientAgent(/ToutiaoMicroApp/i);
}

/**
 * 微信小程序
 */
export function isWeapp() {
    return isClientAgent(/miniProgram/i);
}
export function isPC() {
    return !isMobile();
}

export function isMiniapp() {
    return isByteapp() || isWeapp();
}

export function isMobile() {
    return (
        isClientAgent(/Mobile/i) ||
        isIOS() ||
        isAndroid() ||
        // isWindowsPhone() ||
        isClientAgent(/MiuiBrowser/i) ||
        isClientAgent(/BlackBerry/i) ||
        isClientAgent(/Opera Mini/i)
    );
}

export function isBot() {
    return (
        isClientAgent(/Baiduspider/i) ||
        isClientAgent(/googlebot/i) ||
        isClientAgent(/360Spider/i) ||
        isClientAgent(/sosospider/i) ||
        isClientAgent(/sogou spider/i) ||
        isClientAgent(/spider/i)
    );
}